import { z } from "zod";
import { optionalFilterString } from "@/schemas/filter.schema";

export const damageFilterSchema = z.object({
	search: optionalFilterString,
	vehicleId: optionalFilterString,
	statuses: optionalFilterString,
	period: optionalFilterString,
});

export type DamageFilters = z.infer<typeof damageFilterSchema>;
